import { z } from "zod";

import {
  addCustomFieldIssues,
  addressSchema,
  customFieldsSchema,
} from "components/BaseForm";

const isEmail = value => z.string().email().safeParse(value).success;

/**
 * The Entity form schema. Each rule is one the API enforces or the legacy form
 * blocked on. Name uniqueness is checked only by the API.
 */
export const buildEntitySchema = ({ customFieldConfigs }) =>
  z
    .object({
      name: z.string().trim().min(1, "Name is required"),
      urls: z.array(z.string()),
      account_managers: z.array(z.number()),
      external_cc_emails: z
        .string()
        .trim()
        .refine(
          value =>
            !value || value.split(",").every(email => isEmail(email.trim())),
          "Enter valid email addresses, separated by commas"
        ),
      region_id: z.number().nullable(),
      country: z.string().nullable(),
      addresses: z.array(addressSchema),
      alternate_names: z.array(z.string()),
      tags: z.array(z.any()),
      custom_fields: customFieldsSchema,
    })
    .superRefine((values, ctx) => {
      const name = values.name.trim().toLowerCase();
      if (
        values.alternate_names.some(
          alternate => alternate.trim().toLowerCase() === name
        )
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["alternate_names"],
          message: "An alternate name cannot equal the name",
        });
      }

      addCustomFieldIssues(customFieldConfigs, values.custom_fields, ctx);
    });
